/**
 * @generated SignedSource<<84b2b1b26a7763507bd89d947799581b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
export type WidgetTeamScheduleInlineRoutineListItemMutation$variables = {
  routineId: string;
  sectionId: string;
  sequenceNumber: number;
  taskId: string;
  value?: TaskSentiment | null;
};
export type WidgetTeamScheduleInlineRoutineListItemMutation$data = {
  readonly routine: {
    readonly occasion: {
      readonly section: {
        readonly setCheck: {
          readonly checkValue: TaskSentiment | null;
          readonly id: string;
          readonly isCompleted: boolean;
          readonly routineOccasion: {
            readonly status: RoutineOccasionStatus;
          };
        };
      };
    };
  } | null;
};
export type WidgetTeamScheduleInlineRoutineListItemMutation$rawResponse = {
  readonly routine: {
    readonly occasion: {
      readonly section: {
        readonly setCheck: {
          readonly checkValue: TaskSentiment | null;
          readonly id: string;
          readonly isCompleted: boolean;
          readonly routineOccasion: {
            readonly id: string;
            readonly status: RoutineOccasionStatus;
          };
        };
      };
    };
  } | null;
};
export type WidgetTeamScheduleInlineRoutineListItemMutation = {
  rawResponse: WidgetTeamScheduleInlineRoutineListItemMutation$rawResponse;
  response: WidgetTeamScheduleInlineRoutineListItemMutation$data;
  variables: WidgetTeamScheduleInlineRoutineListItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routineId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sectionId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sequenceNumber"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "sequenceNumber",
    "variableName": "sequenceNumber"
  }
],
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "sectionId"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "sentiment",
    "variableName": "value"
  },
  {
    "kind": "Variable",
    "name": "taskId",
    "variableName": "taskId"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkValue",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCompleted",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetTeamScheduleInlineRoutineListItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "RoutineMutation",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "RoutineOccasionMutation",
            "kind": "LinkedField",
            "name": "occasion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "RoutineOccasionSectionMutation",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v8/*: any*/),
                    "concreteType": "TaskExecutionCheck",
                    "kind": "LinkedField",
                    "name": "setCheck",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineOccasion",
                        "kind": "LinkedField",
                        "name": "routineOccasion",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "WidgetTeamScheduleInlineRoutineListItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "RoutineMutation",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "RoutineOccasionMutation",
            "kind": "LinkedField",
            "name": "occasion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "RoutineOccasionSectionMutation",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v8/*: any*/),
                    "concreteType": "TaskExecutionCheck",
                    "kind": "LinkedField",
                    "name": "setCheck",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineOccasion",
                        "kind": "LinkedField",
                        "name": "routineOccasion",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a033401764f42fd0d7c8514f65140e08",
    "id": null,
    "metadata": {},
    "name": "WidgetTeamScheduleInlineRoutineListItemMutation",
    "operationKind": "mutation",
    "text": "mutation WidgetTeamScheduleInlineRoutineListItemMutation(\n  $routineId: ID!\n  $sequenceNumber: Int!\n  $sectionId: ID!\n  $taskId: ID!\n  $value: TaskSentiment\n) {\n  routine(id: $routineId) {\n    occasion(sequenceNumber: $sequenceNumber) {\n      section(id: $sectionId) {\n        setCheck(taskId: $taskId, sentiment: $value) {\n          id\n          checkValue\n          isCompleted\n          routineOccasion {\n            status(calculateNoTasks: true)\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "334fd50eeecfeb7b5dbdf52e825b1112";

export default node;
